export default {
    formId: 'createAreaForm', //'checkoutForm',
    formField: {
      name: {
        name: 'name',
        label: 'Nombre area*',
        requiredErrorMsg: 'El nombre area es requerido.'
      },
      description: {
        name: 'description',
        label: 'Descripcion*',
        requiredErrorMsg: 'La descripcion es requerida.'
      },
    }
};
  